// This hook is used to determine if the optimization test view should be shown for the user.
// It also includes flag and method to force showing new member MHP view from outside (e.g., Dynamic Yield).
import { useState, useEffect } from 'react';
import globalDyHandler from 'core/utils/helpers/dyHandler';

export const useShouldShowTestView = () => {
  const [shouldShowTestView, setShouldShowTestView] = useState(window.isOptTestActive);

  useEffect(() => {
    // Global method, which could be triggered from outside
    globalDyHandler.showTestView = () => {
      setShouldShowTestView(true);
    };
  }, []);

  return shouldShowTestView;
};
